import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import {
  GET_HOLIDAY,
  DELETE_HOLIDAY,
  ADD_HOLIDAY,
  EDIT_HOLIDAY,
} from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import {
  GetHolidaySuccess,
  GetHolidayFailure,
  DeleteHolidaySuccess,
  DeleteHolidayFailure,
  EditHolidaySuccess,
  EditHolidayFailure,
  AddHolidaySuccess,
  AddHolidayFailure,
} from "../Actions/HolidayAction.js";
const V1BE_API_URL = `${process.env.REACT_APP_API_URL}api/admin/holidays`;

function getFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
}

function* EditHolidayRequest(actions) {
  const data = {
    name: actions.payload.name,
    date: actions.payload.date,
    start_time: actions.payload.start_time,
    end_time: actions.payload.end_time,
    is_partial_holiday: actions.payload.is_partial_holiday,
  };
  try {
    const res = yield axios.post(
      V1BE_API_URL + `/${actions.payload.id}`,
      getFormData(data),
      {
        headers: defaultHeaders(),
      }
      
    );
    console.log(V1BE_API_URL+`/${actions.payload.id}`);
    if (res.status === 200) {
      yield put(EditHolidaySuccess(res.data));
    } else yield put(EditHolidayFailure(res));
  } catch (e) {
    yield put(EditHolidayFailure(e));
  }
}

function* AddHolidayRequest(actions) {
  const data = {
    name: actions.payload.name,
    date: actions.payload.date,
    start_time: actions.payload.start_time,
    end_time: actions.payload.end_time,
    is_partial_holiday: actions.payload.is_partial_holiday,
  };
  try {
    const res = yield axios.post(V1BE_API_URL, getFormData(data), {
      headers: defaultHeaders(),
    });
    if (res.status === 200) {
      yield put(AddHolidaySuccess(res.data));
    } else yield put(AddHolidayFailure(res));
  } catch (e) {
    yield put(AddHolidayFailure(e));
  }
}

function* GetHolidayRequest(actions) {
  try {
    const res = yield axios.get(
      V1BE_API_URL +
        `?sort_by=${actions.payload.sort_by}&sort_type=${actions.payload.sort_type}&search_key=${actions.payload.search_key}`,
      {
        headers: defaultHeaders(),
      }
    );

    if (res.status === 200) {
      yield put(GetHolidaySuccess(res.data));
    } else {
      yield put(GetHolidayFailure(res));
    }
  } catch (e) {
    yield alert(JSON.stringify(e));
    yield put(GetHolidayFailure(e));
  }
}

function* DeleteHolidayRequest(actions) {
  try {
    const res = yield axios.delete(
      V1BE_API_URL,

      {
        headers: {
          ...defaultHeaders(),
          holidayId: actions.payload,
        },
      }
    );
    if (res.status === 200) {
      yield put(DeleteHolidaySuccess(res.data));
    } else {
      yield put(DeleteHolidayFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteHolidayFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_HOLIDAY, GetHolidayRequest);
  yield takeLatest(DELETE_HOLIDAY, DeleteHolidayRequest);
  yield takeLatest(ADD_HOLIDAY, AddHolidayRequest);
  yield takeLatest(EDIT_HOLIDAY, EditHolidayRequest);
}

export default function* GetHolidaySaga() {
  yield all([actionWatcher()]);
}
